// extracted by mini-css-extract-plugin
export default {"modalBody":"Enable2FAModal_modalBody__rZSA-","destinationContainer":"Enable2FAModal_destinationContainer__a9o6+"};